"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _modal = _interopRequireDefault(require("../../../core/modal"));

var _mew = _interopRequireDefault(require("./mew"));

var _trust = _interopRequireDefault(require("./trust"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _indexModule = _interopRequireDefault(require("../../../static/styles/index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind.default.bind(_indexModule.default);

const MENU = [{
  key: 'mew',
  label: 'MEW'
}, {
  key: 'trust',
  label: 'Trust Wallet'
}];

class EstablishConnection extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onSelect", key => {
      if (key === 'back') return window.kambriaWallet.back();
      return this.setState({
        model: key
      });
    });

    _defineProperty(this, "onConnect", data => {
      this.done(null, data);
    });

    _defineProperty(this, "menu", () => {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: cx("nav", "nav-tabs")
      }, MENU.map(item => {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: item.key,
          className: cx("nav-item")
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: cx("nav-link", {
            "active": this.state.model === item.key
          }),
          style: {
            cursor: "pointer",
            padding: "0.5rem"
          },
          onClick: () => {
            this.onSelect(item.key);
          }
        }, item.label));
      }));
    });

    _defineProperty(this, "device", () => {
      if (this.state.model === 'mew') return /*#__PURE__*/_react.default.createElement(_mew.default, {
        done: this.onConnect
      });
      if (this.state.model === 'trust') return /*#__PURE__*/_react.default.createElement(_trust.default, {
        done: this.onConnect
      });
    });

    this.state = {
      model: 'mew'
    };
    this.done = props.done;
    this.onClose = props.onClose;
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      visible: true,
      className: cx("fade", "wallet-modal", "hybrid-wallet"),
      dialogClassName: cx("modal-dialog-centered")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("modal-body")
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: cx("close-button"),
      onClick: this.onClose
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: cx("title", "d-block", "text-center", "mt-4")
    }, "Hybrid Wallet"), /*#__PURE__*/_react.default.createElement("span", {
      className: cx("position-absolute"),
      style: {
        cursor: "pointer",
        color: "black",
        top: "12px",
        left: "12px"
      },
      onClick: window.kambriaWallet.back
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: cx("fas", "fa-arrow-left")
    }), " Back"), /*#__PURE__*/_react.default.createElement("p", {
      className: cx("subtitle", "d-block", "text-center", "mb-4", "success")
    }, "This is a recommended way to access your wallet."), this.menu(), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("tab-content")
    }, this.device())));
  }

}

var _default = EstablishConnection;
exports.default = _default;